import { AdminUpdatePaymentInput } from '../../graphql/API';
import { venueUpdateInvitePaymentToStop } from '../../graphql/mutations';
import { executeGql } from '../../utils/gql-utils';

export const venueUpdateInvitePaymentToStopApi = async (
  input: AdminUpdatePaymentInput,
): Promise<void> => {
  await executeGql<void>(venueUpdateInvitePaymentToStop, { input });
};
